import React, { useState } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { importEmployees } from '../../services/employeeService';
import { useNavigate } from 'react-router-dom';

const EmployeeImport = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                         'application/vnd.ms-excel'];
      if (!validTypes.includes(selectedFile.type)) {
        setError('Please select a valid Excel file (xlsx or xls)');
        setFile(null);
        return;
      }
      setFile(selectedFile);
      setError(null);
    }
  };

  const handleImport = async () => {
    if (!file) {
      setError('Please select an Excel file');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await importEmployees(file);
      
      if (response.data.failed && response.data.failed.length > 0) {
        setError(`Import completed with errors. ${response.data.imported} rows imported successfully, ${response.data.failed.length} rows failed.`);
        console.error('Failed rows:', response.data.failed);
      } else {
        setSuccess(`Successfully imported ${response.data.imported} employees`);
      }
      
      setTimeout(() => {
        setError(null);
        setSuccess(null);
      }, 5000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to import employees');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Import Employees</h2>
      <p className="mb-4">
        Download the template file and fill it with employee data before uploading.
      </p>

      {success && (
        <Alert variant="success" className="mb-3">
          Successfully imported {success.imported} employees.
          {success.failed.length > 0 && (
            <div className="mt-2">
              <strong>Failed rows:</strong>
              <ul>
                {success.failed.map((fail, index) => (
                  <li key={index}>
                    Row {fail.row}: {fail.error}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Alert>
      )}

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Form>
        <Form.Group controlId="formFile">
          <Form.Label>Select Excel File</Form.Label>
          <Form.Control
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
        </Form.Group>

        <div className="mt-3">
          <Button
            variant="primary"
            onClick={handleImport}
            disabled={loading || !file}
          >
            {loading ? 'Importing...' : 'Import Employees'}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default EmployeeImport;
